module.exports = __webpack_public_path__ + "img/VP-Profi13-User.1ac07f03.jpg";